module.exports = __webpack_public_path__ + "static/media/user-designation.d2e795d9.svg";